import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import InspectionSettings from '../../../components/siteadmin/InspectionSettings';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.inspAdmTitle);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Same privilege as the site settings page (no new privilege row, hence no migration).
  if (!restrictUrls('/siteadmin/settings/site', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><InspectionSettings title={title} /></AdminLayout>,
  };
};
